import { formatVNDShort } from "@/lib/format";

/** Số ngày nghỉ không lương kiểu Việt: 2 · 0,5 · 1,25. */
const DAYS = new Intl.NumberFormat("vi-VN", { maximumFractionDigits: 2 });

/**
 * Tên dòng lương cứng trên phiếu lương (QĐ 0255): số là lương cứng QC thì ghi
 * đúng "Lương cứng QC" — người QC đi làm nghề đọc phiếu phải thấy ngay đây là
 * lương QC, không phải lương cứng của phòng thợ.
 *
 * Tháng không trọn (QĐ 0380 câu 2a — vào / nghỉ giữa tháng): con số là lương
 * cứng đã chia theo ngày, nên tên dòng nói luôn phép chia, vd "Lương cứng (2/31
 * ngày của 8.000.000đ)". Không nói thì người vào ngày 30 thấy 516.129đ dưới chữ
 * "Lương cứng" và tưởng phiếu sai.
 *
 * Người làm hai hệ mà nơi làm chính ở hệ khác (QĐ 0380 câu 10a): lương cứng do
 * nơi đó trả nên ở đây là 0 — tên dòng nói "(nơi làm chính trả)", không thì
 * người đọc thấy "Lương cứng 0đ" và tưởng bị cắt lương.
 *
 * Nghỉ không lương đã duyệt (QĐ 0380 câu 11a): tên dòng nói số ngày đã trừ, vd
 * "Lương cứng (trừ 2 ngày nghỉ không lương, của 8.000.000đ)".
 */
export function baseSalaryLabel(
  r:
    | {
        baseSalaryIsQc?: boolean | undefined;
        baseSalaryFull?: number | undefined;
        baseSalaryDays?: number | undefined;
        baseSalaryMonthDays?: number | undefined;
        baseSalaryPaidElsewhere?: boolean | undefined;
        baseSalaryUnpaidDays?: number | undefined;
      }
    | null
    | undefined,
): string {
  const name = r?.baseSalaryIsQc ? "Lương cứng QC" : "Lương cứng";
  if (r?.baseSalaryPaidElsewhere) return `${name} (nơi làm chính trả)`;
  const monthDays = r?.baseSalaryMonthDays ?? 0;
  if (monthDays <= 0) return name;
  const days = r?.baseSalaryDays ?? 0;
  const full = r?.baseSalaryFull ?? 0;
  const unpaid = r?.baseSalaryUnpaidDays ?? 0;
  if (unpaid <= 0) {
    return full > 0
      ? `${name} (${days}/${monthDays} ngày của ${formatVNDShort(full)})`
      : `${name} (${days}/${monthDays} ngày)`;
  }
  const parts = days < monthDays ? [`${days}/${monthDays} ngày`] : [];
  parts.push(`trừ ${DAYS.format(unpaid)} ngày nghỉ không lương`);
  if (full > 0) parts.push(`của ${formatVNDShort(full)}`);
  return `${name} (${parts.join(", ")})`;
}
